import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { cloneElement, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { colorGray60 } from '@resultadosdigitais/tangram-design-tokens';
const Root = styled.span.withConfig({
  displayName: "Affix__Root",
  componentId: "sc-1ug7wnz-0"
})(["color:var(--color-gray-60);font-weight:var(--text-md-bold);display:flex;align-items:center;min-width:24px;", " ", ""], ({
  category
}) => category === Affix.categories.prefix && css(["margin-right:var(--size-spacing-03);"]), ({
  category
}) => category === Affix.categories.suffix && css(["margin-left:var(--size-spacing-04);"]));
const Affix = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const childrenWithProps = React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return child;
    }

    const _child$props = child.props,
          {
      fill: childFill
    } = _child$props,
          childProps = _objectWithoutPropertiesLoose(_child$props, ["fill"]);

    const newChild = /*#__PURE__*/cloneElement(child, _extends({
      fill: childFill || colorGray60
    }, childProps));
    return newChild;
  });
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref
  }), childrenWithProps);
});
Affix.categories = {
  prefix: 'prefix',
  suffix: 'suffix'
};
process.env.NODE_ENV !== "production" ? Affix.propTypes = {
  category: PropTypes.oneOf([Affix.categories.prefix, Affix.categories.suffix]).isRequired
} : void 0;
export default Affix;